import React, {useEffect} from "react";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment";
import {BackIcon} from "../../../../components/icons/icons";
import {FormControl, MenuItem, Select} from "@mui/material";
import {admissionViewTypes, CalendarViews, SessionsTime} from "../../bookedAdmissions";
import DatePicker from "@mui/lab/DatePicker";
import config from "../../../../app/config";
import {
    getStartDay,
    setNewStartDay,
    reload,
    getAdmissionType,
    getSessionsFiltered,
    getCalendarView,
    setNewCalendarView,
    countDays,
    setNewView,
    getConfig,
    getMarkedOperation,
    getOperationsObject,
    getSpecialtiesFilter,
    getAnaesthetistsFilter,
    getConsultantsFilter,
    getFilterPriority,
    getFilterAnaestheticType, getProcedureFilter, clearFilters, getSurgeonsFilter,
} from '../../../../store/reducers/booked_admissions';
import {useDispatch, useSelector} from "react-redux";
import AgyleToggleButtons from "../../../../components/ui/buttons/agyleToggleButtons";
import AgyleCalendar from "./AgyleCalendar";
import clsx from "clsx";
import LockIcon from "@mui/icons-material/Lock";
import {AdmissionSpecialties} from '../../../../controls/agyle/dictionaries';
import AgyleCalendarDays from './AgyleCalendarDays';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import Slider from '@mui/material/Slider';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import IconButton from '@mui/material/IconButton';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import TuneIcon from '@mui/icons-material/Tune';
import {StyledBadgeAdmission} from '../../patientsLists/patientsList';
import AgyleDialog from '../../../../components/modal/agyleDialog';
import AdmissionFilterModal from '../modals/admissionFilterModal';
import CloseIcon from '@mui/icons-material/Close';
import _ from 'lodash';
export const useStyles = makeStyles((theme) => ({
    statusItem: {
        width: "50%",
        textAlign: "center",
        color: "grey",
        cursor: "pointer",
        padding: 5,
        fontSize: 12,
        borderBottom: "1px solid "+theme.palette.background.default,
    },
    itemSelected: {
        borderBottom: "1px solid "+theme.palette.primary.main,
        color: "white",
        transition: "border 0.6s linear"
    },
    patientsCounter: {
        fontSize: 12,
        padding: 10
    },
    counter: {
        background: "#3d3e40",
        borderRadius: 7,
        padding: 5,
        width: 25,
        display: "inline",
        textAlign: "center"
    },
    day: {
        border: "1px solid white",
        height: "100px",
        textAlign: "center",
        margin: "5px",
        borderRadius: "7px",
    },
    dayOtherMonth: {
        border: "1px solid grey",
        color: "grey",
        pointerEvents: "none",
    },
    daySession: {
        background: "#4eac6f",
        color: "black",
        cursor: "pointer"
    },
    todayButton:{
        color: "#2180F7",
        borderColor: "#2180F7",
        "&:hover": {
            backgroundColor: "#2180F7",
            color: "white",
            borderColor: "#2180F7",
        },
        "&.active": {
            backgroundColor: "#2180F7",
            color: "white",
            borderColor: "#2180F7",
        },
    },
    calendarContent: {
        marginRight: 10
    },
    clearFilterButton: {
        color: "#2180F7",
        fontSize: 12,
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        marginRight: 30
    },
    calendarHeader: {
        marginLeft: 275,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    rotate: {
        transform: "rotate(-180deg)"
    },
    dayNumber: {
        fontSize: "20px",
        textAlign: "center",
        marginLeft: "5px",
        marginTop: "7px",
        width: "30px",
        height: "30px",
        fontWeight: "600"
    },
    otherMonth: {
        color: "grey"
    },
    lockIcon: {
        position: "absolute",
        right: 10,
        top: 10,
    },
    markedDay: {
        // color: "black",
        // background: "white",
        // borderRadius: "100px",
        // width: "30px",
        // height: "30px",
        // textAlign: "center"
    },
    dayFrame: {
        height: "78px",
        borderRadius: 6,
        position: "relative"
    },
    dayFrameToAction: {
        color: "#2180F7",
        border: "1px solid #2180F7"
    },
    today: {
        color: theme.palette.bookAdmissions.calendarDaysTodayText,
        background: theme.palette.bookAdmissions.calendarDaysTodayBackground,
        borderRadius: "100px",
        width: "30px",
        height: "30px",
        textAlign: "center"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb"
    },
    cardText: {
        fontSize: 12,
        textAlign: "left",
        paddingLeft: 10,
        paddingTop: 10
    },
    calendarDay: {
        border: "1px solid " +theme.palette.bookAdmissions.calendarDayBorder,
        height: "80px",
        background: theme.palette.background.paperDarker,
        textAlign: "center",
        margin: "5px",
        borderRadius: "7px",
        display: "grid",
        alignContent: "space-between",
        width: "100%"
    },
    inputClass: {
        borderRadius: 10,
        background: "red"
    }

}));

const AdmissionsCalendar = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const startDay = useSelector(getStartDay);
    const sessionsAll = useSelector(getSessionsFiltered);
    const calendarView = useSelector(getCalendarView);
    const admissionType = useSelector(getAdmissionType);
    const markedOperation = useSelector(getMarkedOperation);

    const operations = useSelector(getOperationsObject);
    const configAdmissions = useSelector(getConfig);

    const [days, setDays] = React.useState(0);
    const [open, setOpen] = React.useState(false);
    const [selectedTime, setSelectedTime] = React.useState(SessionsTime.AM);

    const specialtiesFilter = useSelector(getSpecialtiesFilter);

    const customInputRef = React.useRef();

    useEffect(() => {
        setDays(dispatch(countDays()))
    }, [calendarView])


    const handleCalendarViewChange = (event) => {
        const {value} = event.target;
        dispatch(setNewCalendarView(value));
    }

    const getDateLabel = () => {
        if(calendarView === CalendarViews.month)
            return moment(startDay).format("MMM YYYY")
        if(calendarView === CalendarViews.days1)
            return moment(startDay).format("DD MMM")
        else {
            let endDate = moment(startDay).add(days-1, "days").format("DD MMM YYYY")
            return moment(startDay).format("DD MMM") + " - " + endDate
        }
    }

    const handleChangeDate = (direction) => {
        let newStartDay = moment(startDay).add(direction*days, "days")
        if(calendarView === CalendarViews.month) newStartDay = moment(startDay).add(direction, "month");
        dispatch(setNewStartDay(newStartDay));
    }


    const renderIpCard = (element) => {
        let time = 0;
        let maxTime = 0;
        let markedIsOnDay = false;
        let sessionLock = false;
        let color = "";


        element.dayData?.forEach((con)=>{
            if(markedOperation?.bookedSession === con.id) markedIsOnDay = true;
            if(con.locked) sessionLock = true;

            time = con.bookedSessions.reduce((accumulator, s) => {
                if(!s.holdingPen) return accumulator + s.timeLen;
                else return accumulator;
            }, time);

            maxTime += con.maxTime;
        })

        let p = Math.floor(100*time/maxTime);

        if(configAdmissions) {
            Object.keys(configAdmissions?.dayCardColorRanges).map((range)=> {
                if(p >= range) color = configAdmissions?.dayCardColorRanges[range].color
            })
        }

        return <div style={{background: markedIsOnDay? "linear-gradient(-135deg,white 15px,"+color+" 0)": color}} className={classes.dayFrame}>
            <div className={clsx(classes.dayNumber,
                markedIsOnDay && classes.markedDay,
                element.date === moment().format("DD/MM/YYYY") && classes.today,
                !element.actualMonth && classes.otherMonth)}>
                {element.day}
            </div>

            {sessionLock && <div className={classes.lockIcon}> <LockIcon/> </div>}

            {element.dayData && !element.dayData?.length && <div className={classes.cardText}> No Session</div>}
            {element.dayData && element.dayData.length > 0 && element.actualMonth && <div className={classes.cardText}>{maxTime - time?  maxTime - time + "min" : "FULL" }</div>}

        </div>
    }

    const renderDcCard = (element) => {
        let time = 0;
        let maxTime = 0;
        let markedIsOnDay = false;
        let sessionLock = false;
        let color = "";


        let dontHaveWorkstations = false;
        let dontHaveWorkstationsCount = 0;

        element.dayData?.forEach((con)=>{
            if(markedOperation?.bookedSession === con.id) markedIsOnDay = true;
            if(con.locked) sessionLock = true;

            time = con.bookedSessions.reduce((accumulator, s) => {
                return accumulator + s.timeLen;
                // if(!s.holdingPen) return accumulator + s.timeLen;
                // else return accumulator;
            }, time);

            con.bookedSessions.forEach((session) => {
                if(!session.workStationId && !session.lock) {
                    dontHaveWorkstations = true;
                    dontHaveWorkstationsCount++;
                }
            })
            maxTime += (con.maxTime * con.workStations?.length);
            if(!con.workStations) dontHaveWorkstations = true;
        })

        let p = Math.floor(100*time/maxTime);

        if(configAdmissions && !dontHaveWorkstations) {
            Object.keys(configAdmissions?.dayCardColorRanges).map((range)=> {
                if(p >= range) color = configAdmissions?.dayCardColorRanges[range].color
            })
        }

        return <div style={{background: markedIsOnDay? "linear-gradient(-135deg,white 15px,"+color+" 0)": color}}
                    className={clsx(classes.dayFrame, dontHaveWorkstations && classes.dayFrameToAction)}>
            <div className={clsx(classes.dayNumber,
                markedIsOnDay && classes.markedDay,
                element.date === moment().format("DD/MM/YYYY") && classes.today,
                !element.actualMonth && classes.otherMonth)}>
                {element.day}
            </div>

            {sessionLock && <div className={classes.lockIcon}> <LockIcon/> </div>}

            {dontHaveWorkstations && <div> <div className={classes.lockIcon} style={{display: "flex", alignItems: "center", fontSize: 12}}> {dontHaveWorkstationsCount} <HourglassBottomIcon/></div> </div>}
            {element.dayData && !element.dayData?.length && <div className={classes.cardText}> No Session </div>}
            {!!maxTime && element.dayData && element.dayData.length > 0 && element.actualMonth && <div className={classes.cardText}>{maxTime - time?  maxTime - time + "min" : "FULL" }</div>}

        </div>
    }

    const cardRender = (element) => {
        switch(admissionType) {
            case admissionViewTypes.THEATRES:
                return renderIpCard(element)
            case admissionViewTypes.MDU:
                return renderDcCard(element)
        }
    }


    const selectDayClick = (day) => {
        if(admissionType === admissionViewTypes.THEATRES)
            dispatch(setNewView(moment(day, "DD/MM/YYYY"), CalendarViews.days4));
        else
            dispatch(setNewView(moment(day, "DD/MM/YYYY"), CalendarViews.days1));
    }

    const handleSetToday = () => {
        let today = moment();
       // if(calendarView === CalendarViews.month)  today = today.day(1)
        dispatch(setNewView(moment(), CalendarViews.days1));
    }

    const [filtersVisible, setFilterVisible] = React.useState(false);

    const handleToggleFilterButton  = () => {
        setFilterVisible(!filtersVisible)
    }


    const priority =  useSelector(getFilterPriority);
    const anaestheticType = useSelector(getFilterAnaestheticType)
    const procedureFilter = useSelector(getProcedureFilter);

    const getFilterLength = () => {
        if(admissionType === admissionViewTypes.THEATRES) {
            return specialtiesFilter?.length + consultantsFilter?.length + priority?.length + anaestheticType?.length + anaesthetistsFilter?.length + surgeonsFilter?.length;
        }
        else return procedureFilter? 1: 0;
    }

    const renderCalendarHeader = () => {
        return <div className={classes.calendarHeader}>

            <div style={{display: "flex", alignItems: "center"}}>
                <AgyleButton size={"small"} className={clsx(classes.todayButton, moment().isSame(moment(startDay),"date") && days === 1 && "active")}
                             onClick={handleSetToday}>
                    Today
                </AgyleButton>

                <IconButton
                    onClick={ (e) => handleChangeDate(-1)}
                    size="small"
                >
                    <BackIcon/>
                </IconButton>
                <IconButton
                    onClick={ (e) => handleChangeDate(1)}
                    size="small"
                >
                    <BackIcon  className={classes.rotate}/>
                </IconButton>


                {/*{CalendarViews.month !== calendarView &&*/}
                <DatePicker
                    name={"departureDate"}
                    inputFormat={config.defaultDateFormat}
                    value={startDay}
                    autoOk={true}
                    PopperProps={{ anchorEl: customInputRef.current }}
                    open={open}
                    onChange={ (e) => dispatch(setNewStartDay(e))}
                    disableToolbar={true}
                    inputVariant="outlined"
                    required
                    views={CalendarViews.month !== calendarView? ['day']: ['month', 'year']}
                    onClose={() => {setOpen(false)}}
                    renderInput={({
                                      ref,
                                      inputProps,
                                      disabled,
                                      onChange,
                                      value,
                                      ...other
                                  }) => (
                        <div ref={ref}>
                            <input
                                style={{ display: 'none' }}
                                onChange={onChange}
                                value={value}
                                {...inputProps}
                            />
                            <div style={{
                                display: "flex",
                                fontSize: "1.1rem",
                                alignItems: "center",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis"
                            }} ref={customInputRef} onClick={() => {setOpen(!open)}}>
                                {getDateLabel()}
                                <IconButton size="small" style={{marginLeft: 10}}>
                                    <ArrowDropDownIcon style={{transform: `rotate(${open? -180: -0}deg)`}}/>
                                </IconButton>
                            </div>
                        </div>)} />
                {/*}*/}
            </div>

            <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end", columnGap: 10}}>
                <FormControl variant="outlined" size={"small"} style={{width: "100px"}}>
                    <Select
                        value={calendarView}
                        onChange={handleCalendarViewChange}

                    >
                        <MenuItem value={CalendarViews.days1}>
                            1 Days
                        </MenuItem>
                        {admissionType === admissionViewTypes.THEATRES &&
                        <MenuItem value={CalendarViews.days4}>
                            4 Days
                        </MenuItem>
                        }
                        {admissionType === admissionViewTypes.THEATRES &&
                        <MenuItem value={CalendarViews.days5}>
                            5 Days
                        </MenuItem>
                        }
                        {admissionType === admissionViewTypes.THEATRES &&
                        <MenuItem value={CalendarViews.days7}>
                            7 Days
                        </MenuItem>
                        }
                        <MenuItem value={CalendarViews.month}>
                            month
                        </MenuItem>
                    </Select>
                </FormControl>

                <div>
                    {calendarView !== CalendarViews.month &&
                    <AgyleToggleButtons
                        onChange={(e) => {
                            if(e) setSelectedTime(e)
                        }}
                        value={selectedTime}
                        size="small"
                        options={[
                            {value: SessionsTime.AM, label: configAdmissions?.timeOfDayRanges["am"].startHour},
                            {value: SessionsTime.PM, label: configAdmissions?.timeOfDayRanges["pm"].startHour},
                            {value: SessionsTime.TW, label: configAdmissions?.timeOfDayRanges["twighlight"].startHour},
                        ]}
                        minWidth={50}
                    />
                    }
                </div>
                {admissionType === admissionViewTypes.THEATRES &&
                    // <div style={{width: 200}}>
                    //     <AdmissionSpecialties
                    //         name="AdmissionSpecialties"
                    //         label={"Specialties"}
                    //         color="primary"
                    //         size={"small"}
                    //         value={specialtiesFilter}
                    //         onChange={(e) => dispatch(setSpecialtiesFilter(e))}
                    //     />
                    // </div>
                     <div style={{width: 30}}>
                         <IconButton
                             variant="outlined"
                             onClick={handleToggleFilterButton}
                         >
                             <StyledBadgeAdmission badgeContent={getFilterLength()} color={"primary"}>
                                 <TuneIcon fontSize="small" onClick={handleToggleFilterButton}/>
                             </StyledBadgeAdmission>
                         </IconButton>


                     </div>
                }
            </div>


        </div>
    }
    const consultantsFilter = useSelector(getConsultantsFilter);
    const surgeonsFilter = useSelector(getSurgeonsFilter);
    const anaesthetistsFilter = useSelector(getAnaesthetistsFilter);

    const sessionsAreFiltered = () => {
        return specialtiesFilter?.length > 0 || consultantsFilter?.length > 0 || surgeonsFilter?.length > 0 || anaesthetistsFilter?.length > 0
    }

    const getFilteredSessions = () => {
        if(consultantsFilter.length === 0 && surgeonsFilter.length === 0 && anaesthetistsFilter.length === 0 && specialtiesFilter.length === 0) return sessionsAll

        let filteredSessions = [];

        if(specialtiesFilter && specialtiesFilter.length > 0) {
            filteredSessions = filteredSessions.concat(sessionsAll.filter((ses) => specialtiesFilter.some((specFilter) => specFilter.__code === ses.specialty?.__code)));
        }

        if(consultantsFilter && consultantsFilter.length > 0) {
            filteredSessions = filteredSessions.concat(sessionsAll.filter((ses) => consultantsFilter.some((consFilter) => consFilter.id === ses.consultant?.id)));
        }

        if(surgeonsFilter && surgeonsFilter.length > 0) {
            filteredSessions = filteredSessions.concat(sessionsAll.filter((ses) => surgeonsFilter.some((surFilter) => surFilter.name === ses.surgeon?.name)));
        }

        if(anaesthetistsFilter && anaesthetistsFilter.length > 0) {
            filteredSessions = filteredSessions.concat(sessionsAll.filter((ses) => anaesthetistsFilter.some((anaFilter) => anaFilter.id === ses.anaesthetists?.id)))
        }

        return  _.uniqBy(filteredSessions, (el) => el.id)
    }

    const handleClearFilters = () => {
        dispatch(clearFilters());
    }

    return(<div className={classes.calendarContent}>
            {renderCalendarHeader()}

        <AgyleDialog
            title={"Filters"}
            open={filtersVisible}
            onClose={handleToggleFilterButton}
            fullWidth={true}
            closeButtonOnHeader
            onSave={handleToggleFilterButton}
            width={"sm"}
            disableActionsCloseButton
            contentStyle={classes.dialogContentStyle}
            submitText={"Apply"}
            buttons={[
                <div className={classes.clearFilterButton} onClick={handleClearFilters}>
                    <CloseIcon fontSize={"small"}/> Clear Filters
                </div>
            ]}
        >
            <AdmissionFilterModal/>
        </AgyleDialog>
            <div>
                {calendarView === CalendarViews.month && <AgyleCalendar cardRender={cardRender}
                                                                        handleOnClick={selectDayClick}
                                                                        calendarAvailable={false}
                                                                        date={startDay}
                                                                        selectedDayClass={classes.daySession}
                                                                        dayClass={classes.calendarDay}
                                                                        sessionsAreFiltred={sessionsAreFiltered()}
                                                                        values={getFilteredSessions()}/>
                }
                {calendarView !== CalendarViews.month  && <AgyleCalendarDays startDay={startDay}
                                                                            selectedTime={selectedTime}
                                                                            days={dispatch(countDays())}
                                                                            data={operations} daysCount={days}
                                                                            sessions={getFilteredSessions()}/>
                }

            </div>
    </div>)
}

export default AdmissionsCalendar